<template>
  <div>
    <md-card class="island-card">
      <md-card-header>
        <div class="md-title">Rental Terms</div>
        <div class="moow-info-txt small" v-if="readonly">
          <i>View Only</i>
        </div>
      </md-card-header>
      <md-card-content>
        <b-row>
          <b-col cols="12" md="5">
            <md-checkbox
              v-model="termless"
              :value="true"
              v-if="canBeTermless"
              :disabled="readonly"
            >Unspecified Term</md-checkbox>
            <md-switch
              v-model="monthly"
              class="md-primary"
              :disabled="readonly"
            >{{getDisplayRentPeriod(monthly)}}</md-switch>

            <b-row>
              <b-col v-if="termless" xs="12">
                <p
                  class="moow-info-txt small"
                >Unspecified term requires advanced notice period - a minimum time tenant needs to be notificed before ending the contract</p>
              </b-col>
              <b-col v-else xs="12">
                <p
                  class="moow-info-txt small"
                >Move in / out dates will be also be the contract start and termination dates</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col xs="12">
                <dialog-date-picker
                  :show-dialog="showStartDateDialog"
                  :allowed-dates="blockedDatesFilter"
                  @emitCancel="showStartDateDialog = false"
                  @emitClear="startDate = null"
                  @emitSelectedDate="handleStartDateSelectedEvent"
                  label="Select date"
                  dialog-title="Start / Move In"
                  md-immediately
                ></dialog-date-picker>
                <md-field :class="{ 'md-invalid': inputErr_periodStart }">
                  <label>Start / Move In</label>
                  <md-input
                    :value="startDate | formatDate"
                    :disabled="readonly"
                    @click="showStartDateDialog = true"
                  ></md-input>
                  <span class="md-error">{{inputErr_periodStart}}</span>
                </md-field>
                <div v-if="canBeTermless && termless">
                  <b-row class="mt-3">
                    <b-col>
                      <date-input
                        ref="dateInputFormRef_notice"
                        :date="noticeGiven"
                        title="Notice Given"
                        hint="(optional)"
                      />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col xs="12" md="8">
                      <md-field :class="{ 'md-invalid': inputErr_notice }">
                        <!-- <md-icon class="md-accent">warning</md-icon> -->
                        <label>Notice Period</label>
                        <md-input
                          v-model="noticePeriod"
                          type="number"
                          placeholder="Notice period (min 1)"
                          :readonly="readonly"
                        ></md-input>
                        <span class="md-suffix">months</span>
                        <span class="md-error">{{inputErr_notice}}</span>
                      </md-field>
                    </b-col>
                  </b-row>
                </div>

                <dialog-date-picker
                  :show-dialog="showEndDateDialog"
                  :allowed-dates="blockedDatesFilter"
                  @emitCancel="showEndDateDialog = false"
                  @emitClear="endDate = null"
                  @emitSelectedDate="handleEndDateSelectedEvent"
                  label="Select date"
                  dialog-title="End / Move out"
                  md-immediately
                ></dialog-date-picker>
                <md-field v-if="!termless" :class="{ 'md-invalid': inputErr_periodEnd }">
                  <label>End / Move out</label>
                  <md-input
                    :value="endDate | formatDate"
                    :disabled="readonly"
                    @click="showEndDateDialog = true"
                  ></md-input>
                  <span class="md-error">{{inputErr_periodEnd}}</span>
                </md-field>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" md="5">
            <b-row>
              <b-col md="6" cols="12">
                <md-field :class="{ 'md-invalid': inputErr_rentPrice }">
                  <label>{{getDisplayRentPeriod(monthly)}} rent</label>
                  <md-input v-model="price" type="number" :readonly="readonly"></md-input>
                  <span v-if="!monthly" class="md-helper-text">No automatic lease agreement</span>

                  <span class="md-error">{{inputErr_rentPrice}}</span>
                  <md-icon class="md-primary">euro_symbol</md-icon>
                </md-field>
              </b-col>
              <b-col md="6" cols="12">
                <md-field
                  v-if="monthly"
                  :class="{ 'md-invalid': inputErr_rentDueDay }"
                  :md-counter="false"
                >
                  <label>Monthly rent due date</label>
                  <md-input v-model="rentDueDay" :readonly="readonly" maxlength="2"></md-input>
                  <span class="md-error">{{inputErr_rentDueDay}}</span>
                  <md-icon class="md-primary">event</md-icon>
                </md-field>
              </b-col>
            </b-row>

            <md-field :class="{ 'md-invalid': inputErr_deposit }">
              <label>Deposit</label>
              <md-input v-model="deposit" type="number" :readonly="readonly"></md-input>
              <span class="md-error">{{inputErr_deposit}}</span>
              <md-icon>euro_symbol</md-icon>
            </md-field>
            <!-- <p class="moow-info-txt">Additional fees</p> -->

            <b-row v-for="(data, index) in additionalFees" :key="index">
              <b-col cols="3">
                <md-field>
                  <label>Fee</label>
                  <md-input v-model="data.fee" :readonly="readonly"></md-input>
                  <md-icon>euro_symbol</md-icon>
                </md-field>
              </b-col>
              <b-col cols="7">
                <md-field>
                  <label>Description</label>
                  <md-input v-model="data.desc" :readonly="readonly"></md-input>
                </md-field>
              </b-col>

              <b-col cols="2" v-if="!readonly">
                <md-button class="md-icon-button" @click="removeAdditionalCost(index)">
                  <md-icon>clear</md-icon>
                </md-button>
              </b-col>
            </b-row>
            <md-button
              v-if="!readonly"
              class="md-raised md-primary play-cta-button white"
              @click="addAdditionalCost()"
            >Add Additional Cost</md-button>
          </b-col>
        </b-row>
      </md-card-content>
    </md-card>

    <!-- Allow to edit accounting period, last minute, in addition to under Manage view -->
    <!-- <md-card class="island-card" v-if="monthly">
      <md-card-header>
        <div class="md-title">Accounting Period</div>
        <div class="moow-info-txt small">Rental period that is used in the accounting for this deal.</div>
        <div class="moow-info-txt small" v-if="readonly">
          <i>View Only</i>
        </div>
      </md-card-header>
      <md-card-content>
        <b-row>
          <b-col cols="6" lg="3">
            <md-field>
                  <label>From</label>
                  <md-input v-model="startDay" :readonly="readonly"  type="number"></md-input>
                </md-field>
          </b-col>
                    <b-col cols="6" lg="3">
            <md-field>
                  <label>To</label>
                  <md-input v-model="endDay" :readonly="readonly"  type="number"></md-input>
                </md-field>
          </b-col>
        </b-row>
      </md-card-content>
    </md-card> -->

    <md-card class="island-card">
      <md-card-header>
        <div class="md-title">House Rules</div>
        <div class="moow-info-txt small" v-if="readonly">
          <i>View Only</i>
        </div>
      </md-card-header>
      <md-card-content>
        <b-row class="mt-5">
          <b-col cols="6">
            <house-rules ref="houseRulesFormRef" :readonly="readonly" :rules="houseRules" />
          </b-col>
        </b-row>
      </md-card-content>
    </md-card>
  </div>
</template>
<script>
import { formatTimeToMonthDDYY, formatTimeToDDMMYY } from "@/timeFunctions";
import DateInput from "@/components/utils/dateInput.vue";
import HouseRules from "@/components/listingComponents/houseRulesSelector.vue";
import DialogDatePicker from "@/components/dialogs/dialogDatePicker.vue";
import { mapFields } from "vuex-map-fields";
import { mapActions, mapState } from "vuex";
import moment from "moment";

export default {
  props: {
    readonly: {
      type: Boolean,
      default: false
    }
  },
  components: {
    "house-rules": HouseRules,
    "date-input": DateInput,
    DialogDatePicker
  },
  data() {
    return {
      inputErr_rentPrice: "",
      inputErr_deposit: "",
      inputErr_periodEnd: "",
      inputErr_periodStart: "",
      inputErr_notice: "",
      inputErr_rentDueDay: "",
      showStartDateDialog: false,
      showEndDateDialog: false,
      startDate: null,
      endDate: null
    };
  },
  watch: {
    termless: function(val, oldVal) {
      if (val != oldVal && val == true) this.inputErr_periodEnd = "";
    },
    periodEnd: function(val, oldVal) {
      if (val != oldVal) this.inputErr_periodEnd = "";
    },
    periodStart: function(val, oldVal) {
      if (val != oldVal) this.inputErr_periodStart = "";
    },
    noticePeriod: function(val, oldVal) {
      if (val != oldVal) this.inputErr_notice = "";
    },
    rentDueDay: function(val) {
      if (val < 0) this.inputErr_rentDueDay = "Must positive";
      else if (isNaN(val)) this.inputErr_rentDueDay = "Must be number";
      else this.inputErr_rentDueDay = "";
    },
    deposit: function(val) {
      if (val < 0) this.inputErr_deposit = "Must be positive";
      else this.inputErr_deposit = "";
    },
    price: function(val) {
      if (!val) this.inputErr_rentPrice = "Required";
      else if (val < 0) this.inputErr_rentPrice = "Must be positive";
      else  this.inputErr_rentPrice = "";
    },
    startDate: function(val, oldVal) {
      if (val && val != oldVal) this.inputErr_periodStart = "";
    },
    endDate: function(val, oldVal) {
      if (val && val != oldVal) this.inputErr_periodEnd = "";
      if(this.startDate){
        var a = moment(this.startDate);
        var b = moment(this.endDate);
        if(a.diff(b, 'days') >= 31){
          this.monthly = true
        }
        
      }
    }
  },
  computed: {
    ...mapState("propertyCalendarModule", ["entries"]),
    ...mapFields([
      "terms.monthly",
      "terms.price",
      "terms.deposit",
      "terms.termless",
      "terms.periodEnd",
      "terms.periodStart",
      "terms.noticePeriod",
      "terms.noticeGiven",
      "terms.additionalFees",
      "terms.rentDueDay",
      "terms.accountingPeriod.startDay",
      "terms.accountingPeriod.endDay",
      "contract.contractType",
      "houseRules"
    ]),
    canBeTermless() {
      return this.contractType != "accomodationTC";
    },
    moveOutRequired() {
      if (this.contractType == "accomodationTC") {
        this.termless = false;
        return true;
      }
      return false;
    }
  },
  async created() {
    await this.getEntries({
      propertyId: this.$store.state.dealApplicationModule.property._id
    });
    if (this.periodStart) {
      this.startDate = new Date(this.periodStart);
    }
    if (this.periodEnd) {
      this.endDate = new Date(this.periodEnd);
    }
  },
  methods: {
    ...mapActions("propertyCalendarModule", [
      "checkAvailability",
      "getEntries"
    ]),
    handleStartDateSelectedEvent($event) {
      this.startDate = $event;
      this.showStartDateDialog = false;
    },
    handleEndDateSelectedEvent($event) {
      this.endDate = $event;
      this.showEndDateDialog = false;
    },
    blockedDatesFilter(currentDate) {
      if (!Array.isArray(this.entries) || !this.entries.length) {
        return false;
      }
      for (const entry of this.entries) {
        const startDate = new Date(entry.startDate);
        const endDate = new Date(entry.endDate);
        if (
          currentDate >= startDate &&
          (currentDate <= endDate || entry.termless)
        ) {
          return true;
        }
      }

      return false;
    },
    addAdditionalCost() {
      this.additionalFees.push({ desc: "", fee: 0.0 });
    },
    removeAdditionalCost(index) {
      console.log("removeAdditionalCost");

      this.additionalFees.splice(index, 1);
    },
    getDisplayRentPeriod(isMonthly) {
      var res = "";
      isMonthly ? (res = "Monthly") : (res = "Daily");
      return res;
    },
    // TODO: instead, create a mix-in and plug it in
    async checkPropertyAvailability(request) {
      return await this.checkAvailability({
        propertyId: this.$store.state.dealApplicationModule.property._id,
        startDate: new Date(request.periodStart).toISOString(),
        endDate: new Date(request.periodEnd).toISOString(),
        termless: Boolean(request.termless)
      });
    },
    async validateForm() {
      try {
        var success = true;

        const periodStart = this.startDate
          ? moment(this.startDate).format("YYYY-MM-DD")
          : null;
        const periodEnd = this.endDate
          ? moment(this.endDate).format("YYYY-MM-DD")
          : null;
        const termless = this.$store.getters.terms.termless;
        const noticePeriod = this.$store.getters.terms.noticePeriod;

        if (periodStart) this.$store.commit("DA_SET_PERIOD_START", periodStart);
        else {
          this.inputErr_periodStart = "Required";
          success = false;
        }

        if(periodStart && periodEnd){
          if(periodStart > periodEnd){
            this.inputErr_periodStart = "Cannot be after move out";
            success =false;
          }
          
        } 

        if (periodEnd) this.$store.commit("DA_SET_PERIOD_END", periodEnd);
        else if (!termless) {
          // no periodEnd AND not termless
          this.inputErr_periodEnd = "Required";
          success = false;
        }

        if (termless && (!noticePeriod || noticePeriod <= 0)) {
          this.inputErr_notice = "Min period is 1";
          success = false;
        }
        if (
          this.rentDueDay &&
          (isNaN(this.rentDueDay) || this.rentDueDay < 0)
        ) {
          this.inputErr_rentDueDay = "Must be a positive number";
          success = false;
        } else if (!this.rentDueDay) this.rentDueDay = 10;

        const price = this.$store.getters.terms.price;
        if (!price) {
          this.inputErr_rentPrice = "Required";
          success = false;
        } else if (price < 0) {
          this.inputErr_rentPrice = "Must be positive";
          success = false;
        }

        if (this.deposit && (isNaN(this.deposit) || this.deposit < 0)) {
          this.inputErr_deposit = "Must be positive number";
          success = false;
        } else if (!this.deposit) this.deposit = 0;

        if (!success) return false; //don't allow to proceed to checkPropertyAvailability

        if (
          !(await this.checkPropertyAvailability({
            periodStart,
            periodEnd,
            termless
          }))
        ) {
          this.notifyUser(
            "Selected dates are not available for chosen property"
          );
          this.inputErr_periodStart =
            "Selected period conflicts with other entries";
          this.inputErr_periodEnd =
            "Selected period conflicts with other entries";
          success = false;
        }

        const houseRules = this.$refs.houseRulesFormRef.getRules();
        this.$store.commit("DA_SET_HOUSE_RULES", houseRules);
        return success;
      } catch (error) {
        this.notifyUser(
          "An error occurred while checking the property availability for selected dates"
        );
      }
    },
    notifyUser(title, msg) {
      this.$notify({
        title: title,
        message: msg
      });
    }
  },
  filters: {
    formatDate(value) {
      if (!value) {
        return "";
      }

      return moment(value).format("DD MMM YYYY") || "";
    }
  }
};
</script>
<style scoped>
@import "../../../assets/styles/global.css";
</style>



// WEBPACK FOOTER //
// src/components/bookings/deals/rentalTerms.vue